import {
  baseStringMethods,
  ConvertMethod,
  EmailResult,
  Extractor,
  InboxResult,
  JsonResult,
  NumberResult,
  ParseMethod,
  ResultType,
  ResultTypesEnum,
  SplitString,
  StringModifier,
  TagConverter,
  TransformerIdsEnum,
  UrlConverter,
  UrlResult,
} from './internal';

export const stringType: ResultType = {
  name: ResultTypesEnum.STRING,
  properties: {
    length: NumberResult,
  },
  methods: {
    ...baseStringMethods,
    [TransformerIdsEnum.CAPITALIZE]: new StringModifier(),
    [TransformerIdsEnum.EXTRACT_URLS]: new Extractor(UrlResult),
    [TransformerIdsEnum.EXTRACT_EMAILS]: new Extractor(EmailResult),
    [TransformerIdsEnum.SPLIT]: new SplitString(),
    [TransformerIdsEnum.TO_NUMBER]: new ParseMethod(NumberResult),
    [TransformerIdsEnum.TO_EMAIL]: new ParseMethod(EmailResult),
    [TransformerIdsEnum.TO_URL]: new UrlConverter(),
    [TransformerIdsEnum.TO_JSON]: new ParseMethod(JsonResult),
    [TransformerIdsEnum.TO_TAG]: new TagConverter(),
    [TransformerIdsEnum.TO_INBOX]: new ConvertMethod(InboxResult),
  },
};
